import React from 'react';
import { constants } from 'smooth-dnd';

const { wrapperClass } = constants;

interface DraggableProps {
  children: React.ReactElement;
  className?: string;
  disabled?: boolean;
}

const Draggable: React.FC<DraggableProps> = ({
  className,
  disabled,
  children,
}): React.ReactElement => {
  return <div className={`${className ?? ''} ${disabled ? '' : wrapperClass}`}>{children}</div>;
};

export default Draggable;
